import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = { class: "row gx-2 gx-lg-3 justify-content-center my-lg-1" }
const _hoisted_3 = { class: "col-4 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2" }
const _hoisted_4 = { class: "col-4 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "col-4 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "col-5 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "col-5 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "js-colorbox-close btn btn-reset rounded-pill w-100 py-2 px-xxl-5",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideRentalContractModal()))
        }, " 戻る ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "js-colorbox-close btn btn-c03 rounded-pill w-100 py-2 px-xxl-5",
          disabled: _ctx.rentalContractEditForm.isDisableButtons.registration,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickRentalContractRegistrationButton()))
        }, " 登録 ", 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "js-colorbox-close btn btn-c01 rounded-pill w-100 py-2 px-xxl-5",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickRentalContractCompleteButton())),
          disabled: _ctx.rentalContractEditForm.isDisableButtons.complete
        }, " 完了 ", 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "js-colorbox-close btn btn-warning rounded-pill w-100 py-2 px-xxl-5",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickRentalContractExportButton())),
          disabled: _ctx.rentalContractEditForm.isDisableButtons.export
        }, " 出力 ", 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          class: "js-colorbox-close btn btn-c02 rounded-pill w-100 py-2 px-xxl-5",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyLineClipboardByRentalContract())),
          disabled: _ctx.rentalContractEditForm.isDisableButtons.export
        }, " LINEコピー ", 8, _hoisted_11)
      ])
    ])
  ]))
}